export default {
  nav: { home: "Inicio", treatments: "Tratamientos", about: "Sobre mí", studio: "Estudio", contact: "Contacto" },
  cta: {
    book: "Reservar cita",
    discover: "Descubrir tratamientos",
    moreAbout: "Más sobre mí",
    allTreatments: "Todos los tratamientos",
    send: "Enviar solicitud",
    sending: "Enviando…",
    call: "Llamar ahora",
    whatsapp: "Escribir por WhatsApp",
    backHome: "Volver al inicio",
    discoverStudio: "Descubrir el estudio",
    request: "Solicitar cita",
    readMore: "Saber más",
  },
  header: { openMenu: "Abrir menú", closeMenu: "Cerrar menú", languageLabel: "Elegir idioma" },
  home: {
    heroEyebrow: "Beauty & Wellness · Basilea",
    heroLines: ["Belleza.", "Relajación.", "Bienestar."],
    heroWelcomePre: "Bienvenida a",
    heroWelcomeBrand: "IMPERIUM.",
    heroSub: "Cosmética profesional y masajes placenteros para más luminosidad, calma y bienestar.",
    heroQuote: "«Atención personal, tratamientos de alta calidad y un ambiente en el que puedes ser completamente tú misma.»",
    trustNo: "01",
    trustEyebrow: "Confianza",
    trustTitle: "La belleza comienza con confianza.",
    trustText: "Tu piel, tu cuerpo y tu bienestar merecen atención. En IMPERIUM se unen tratamiento profesional, asesoramiento personal y un ambiente en el que puedes sentirte completamente a gusto.",
    trustPoints: ["Atención personal", "Tratamiento individual", "Ambiente de alta calidad", "Cosmética profesional", "Tiempo para tus necesidades"],
    servicesNo: "02",
    servicesEyebrow: "Tratamientos",
    servicesTitle: "¿Qué quieres poner hoy en el centro?",
    servicesIntro: "Masajes, cosmética y styling – cada tratamiento adaptado individualmente a ti.",
    auszeitNo: "03",
    auszeitEyebrow: "Tu pausa",
    auszeitTitle: "Tu pausa comienza en el momento en que te eliges a ti misma.",
    auszeitText: "Deja la rutina atrás por un momento. Siente calma, cuidado y energía nueva – adaptada a ti.",
    ablaufEyebrow: "Cómo funciona",
    ablaufTitle: "Así de fácil comienza tu momento Imperium",
    steps: [
      { t: "Elegir el tratamiento", d: "Descubres lo que hoy te hace sentir bien." },
      { t: "Ponerte en contacto", d: "Muy fácil: por formulario, WhatsApp o llamada." },
      { t: "Recibir asesoramiento personal", d: "Lo adaptamos todo a ti y a tus deseos." },
      { t: "Llegar relajada", d: "Entras y la rutina se queda fuera." },
      { t: "Disfrutar del tratamiento", d: "Tu momento Imperium – solo para ti." },
    ],
    expertNo: "04",
    expertEyebrow: "Tu experta",
    expertName: "Leidiane Alcântara",
    expertText: "Profesional de la estética y el bienestar – con dedicación, formación continua y una mirada atenta a las necesidades individuales de cada persona.",
    studioNo: "05",
    studioEyebrow: "El estudio",
    studioTitle: "Un espacio que nace con amor por los detalles.",
    studioText: "En Basilea está naciendo IMPERIUM Beauty & Wellness – un estudio moderno, elegante y confortable, creado para una experiencia completa de belleza, cuidado y bienestar.",
    galleryEyebrow: "Galería",
    galleryTitle: "Miradas al mundo de IMPERIUM",
    finalTitle: "¿Lista para tu pausa más bonita?",
    finalText: "Tómate tiempo para ti. Estaré encantada de conocerte en persona.",
    marquee: ["Estética", "Masajes", "Drenaje linfático", "Cuidado facial", "Maquillaje", "Bienestar"],
  },
  treatmentsPage: {
    eyebrow: "Tratamientos",
    title: "Tus tratamientos en IMPERIUM",
    intro: "Masajes, cosmética y styling – descubre lo que hoy te hace sentir bien. Cada tratamiento se adapta individualmente a ti.",
    massage: "Masajes & Cuerpo",
    beauty: "Cosmética & Styling",
  },
  treatment: {
    back: "Todos los tratamientos",
    related: "Más tratamientos",
    ctaTitle: "Solicitar este tratamiento",
    ctaText: "Cuéntame tus deseos – te asesoraré personalmente y encontraremos juntas tu momento Imperium.",
  },
  about: {
    eyebrow: "Sobre mí",
    title: "Leidiane Alcântara",
    role: "Estética & Bienestar",
    bio: [
      "Soy Leidiane Alcântara, profesional de la estética y el bienestar – apasionada por cuidar a las personas y resaltar lo más bello de cada una de ellas.",
      "Con dedicación, formación continua y una mirada atenta a las necesidades individuales, he construido mi trayectoria con mucho trabajo, responsabilidad y amor por lo que hago.",
      "Creo que cada persona es única. Por eso ofrezco una atención personalizada, con técnicas modernas y seguras – siempre priorizando el cuidado, la estética y el bienestar.",
    ],
    storyEyebrow: "La historia",
    storyTitle: "El sueño de IMPERIUM",
    story: [
      "Ahora estoy cumpliendo un gran sueño: abro IMPERIUM Beauty & Wellness – un precioso estudio, creado especialmente para ofrecer una experiencia completa de belleza, cuidado y bienestar.",
      "Cada detalle se prepara con mucho cariño para que cada cliente se sienta acogida, valorada y viva un momento único, en un ambiente moderno, elegante y confortable.",
      "Será un lugar donde la estética, la relajación y la autoestima se encuentran – porque cuidar de ti es mi mayor misión.",
    ],
    quote: "«Cuidar de ti es mi mayor misión.»",
    philosophyEyebrow: "Filosofía",
    philosophyTitle: "Cada persona es única.",
    philosophyText: "Atención personal, técnicas modernas y seguras – siempre con el foco en el cuidado, la estética y el bienestar.",
    ctaTitle: "Conozcámonos.",
    ctaText: "Espero tu mensaje con alegría – personal, sencillo y sin compromiso.",
  },
  studio: {
    eyebrow: "Estudio",
    title: "IMPERIUM en Basilea",
    intro: "Un estudio creado para la belleza, el cuidado y el bienestar – moderno, elegante y confortable.",
    preparing: "El estudio se está preparando actualmente con mucho amor por los detalles. Cada rincón nace con el objetivo de que te sientas bienvenida y valorada desde el primer momento.",
    locationLabel: "Ubicación",
    location: "Austrasse 31, 4051 Basel, Switzerland",
    ctaTitle: "Participa desde el principio.",
    ctaText: "Escríbeme – estaré encantada de saber de ti.",
  },
  contact: {
    eyebrow: "Contacto",
    title: "Tu momento Imperium comienza aquí.",
    intro: "Preguntas, deseos o citas – escríbeme. Te responderé personalmente.",
    locationLabel: "Ubicación",
    phoneLabel: "Teléfono y WhatsApp",
    emailLabel: "E-mail",
    instagramLabel: "Instagram",
    formTitle: "Enviar solicitud",
  },
  form: {
    name: "Nombre y apellido",
    email: "E-mail",
    phone: "Teléfono (opcional)",
    treatment: "Tratamiento",
    treatmentPlaceholder: "Seleccionar tratamiento",
    noPreference: "Aún no lo sé / Asesoramiento",
    message: "Mensaje",
    messagePlaceholder: "¿En qué puedo ayudarte?",
    privacy: "He leído la política de privacidad y acepto el tratamiento de mis datos para responder a mi solicitud.",
    submit: "Enviar solicitud",
    sending: "Enviando…",
    success: "¡Muchas gracias! Tu solicitud ha llegado. Te responderé personalmente lo antes posible.",
    error: "Ha ocurrido un error. Inténtalo de nuevo o escríbeme por WhatsApp.",
    required: "Completa todos los campos obligatorios.",
    invalidEmail: "Introduce una dirección de e-mail válida.",
    privacyRequired: "Confirma la política de privacidad.",
  },
  footer: {
    tagline: "Estética · Masajes · Bienestar",
    navTitle: "Navegación",
    treatmentsTitle: "Tratamientos",
    contactTitle: "Contacto",
    legalTitle: "Legal",
    impressum: "Impressum",
    privacy: "Privacidad",
    rights: "Todos los derechos reservados.",
    location: "Austrasse 31, 4051 Basel, Switzerland",
  },
  impressum: {
    title: "Impressum",
    operatorLabel: "Titular",
    operator: "IMPERIUM Beauty & Wellness — Leidiane Alcântara",
    contactLabel: "Contacto",
    contentLabel: "Responsable del contenido",
    note: "Los demás datos legales se están completando actualmente y se añadirán en breve.",
  },
  privacyPage: {
    title: "Política de privacidad",
    responsibleTitle: "Responsable",
    responsibleText: "IMPERIUM Beauty & Wellness — Leidiane Alcântara, Austrasse 31, 4051 Basel, Switzerland.",
    dataTitle: "Datos del formulario de contacto",
    dataText: "Cuando me escribes a través del formulario, tus datos (nombre, e-mail, teléfono, mensaje) se utilizan exclusivamente para responder a tu solicitud y no se ceden a terceros.",
    storageTitle: "Almacenamiento en el navegador",
    storageText: "Este sitio web solo guarda tu elección de idioma y tu decisión sobre cookies localmente en tu navegador. No se utilizan cookies de seguimiento.",
    rightsTitle: "Tus derechos",
    rightsText: "Tienes derecho en todo momento a acceder, rectificar o eliminar tus datos. Escribe simplemente a kontakt@imperium-wellness.ch.",
  },
  google: { label: "IMPERIUM en Google", rate: "Valora en Google", reviews: "Ver reseñas" },
  notfound: {
    title: "404",
    heading: "Esta página no se ha encontrado.",
    text: "Quizá encuentres aquí lo que buscas:",
  },
  cookie: {
    text: "Este sitio web utiliza solo almacenamiento técnicamente necesario – por ejemplo, tu elección de idioma. No se instalan cookies de seguimiento.",
    accept: "Entendido",
    more: "Privacidad",
  },
  seo: {
    homeTitle: "IMPERIUM Beauty & Wellness | Cosmética, Estética y Masajes en Basilea",
    homeDesc: "Cosmética profesional y masajes placenteros para más luminosidad, calma y bienestar. Tu belleza. Tu momento. Tu Imperium.",
  },
};
